import styled from 'styled-components';

export const ViewerContainer = styled.div<{ $enhanced?: boolean }>`
  background: var(--surface);
  border-radius: var(--radius);
  margin: 0;
  position: relative;
  overflow: hidden;
`;

export const ViewerLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  padding: 6px 12px;
  background: var(--surface);
  border-bottom: 1px solid var(--line);
  color: var(--ink-2);
  font-family: var(--f-mono);
  font-size: 12.5px;
`;

export const MediaContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  background: #000;
`;

export const MediaWrapper = styled.div`
  position: relative;
  width: 100%;
  height: clamp(320px, 56vh, 720px);
  overflow: hidden;
`;

export const StyledVideo = styled.video`
  width: 100%;
  height: 100%;
  object-fit: contain; /* Ensures aspect ratio is preserved */
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 4px;
  z-index: 0;
`;

export const StyledImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain; /* Ensures aspect ratio is preserved */
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 4px;
  z-index: 0;
`;

export const SegmentationOverlay = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain; /* Ensures aspect ratio is preserved */
  pointer-events: none;
  z-index: 1;
`;

export const SegmentationLabel = styled.div`
  position: absolute;
  bottom: 10px;
  left: 10px;
  background: rgba(0, 0, 0, 0.7);
  color: var(--ink);
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  z-index: 2;
`;

export const ClearButton = styled.span`
  margin-left: 10px;
  cursor: pointer;
  font-size: 14px;
  &:hover {
    color: #ff4d4f;
  }
`;

// existing ToggleButtonWrapper…
export const ToggleButtonWrapper = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 3;

  .ant-btn {
    background: rgba(15, 17, 21, 0.82) !important;
    border: 1px solid var(--line) !important;
    color: rgba(255, 255, 255, 0.9) !important;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25) !important;
    transition: all 0.2s ease;

    &:hover {
      background: var(--surface-sel) !important;
      color: var(--ink) !important;
      transform: scale(1.05);
      box-shadow: 0 3px 12px rgba(0, 0, 0, 0.3) !important;
    }

    &:active {
      transform: scale(0.98);
    }
  }
`;

export const ClearButtonWrapper = styled.div`
  position: absolute;
  top: 19px;
  left: 10px;
  z-index: 3;

  .ant-btn {
    background: rgba(15, 17, 21, 0.82) !important;
    border: 1px solid var(--line) !important;
    color: rgba(255, 255, 255, 0.9) !important;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25) !important;
    transition: all 0.2s ease;

    &:hover {
      background: var(--surface-sel) !important;
      color: var(--ink) !important;
      transform: scale(1.05);
      box-shadow: 0 3px 12px rgba(0, 0, 0, 0.3) !important;
    }

    &:active {
      transform: scale(0.98);
    }
  }
`;

export const DownloadDicomButtonWrapper = styled.div`
  position: static;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
  padding: 8px 12px;
  border-top: 1px solid var(--line);
  background: var(--surface);

  .ant-btn {
    margin: 0 !important;
    background: var(--surface-2);
    border: 1px solid var(--line);
    color: var(--ink);
    box-shadow: none;
  }
  .ant-btn:not(:disabled):hover {
    border-color: var(--accent) !important;
    color: var(--ink) !important;
  }
`;

export const ViewOnReviewerButtonWrapper = styled.div`
  position: absolute;
  bottom: 10px;
  right: 10px;
  z-index: 3;

  .ant-btn {
    background: rgba(15, 17, 21, 0.82) !important;
    border: 1px solid var(--line) !important;
    color: rgba(255, 255, 255, 0.9) !important;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.25) !important;
    transition: all 0.2s ease;
    font-size: 12px;

    &:hover {
      background: var(--surface-sel) !important;
      color: var(--ink) !important;
      transform: scale(1.05);
      box-shadow: 0 3px 12px rgba(0, 0, 0, 0.3) !important;
    }

    &:active {
      transform: scale(0.98);
    }
  }
`;

export const KeypointOverlayDiv = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 2;
`;

export const KeypointDot = styled.div`
  position: absolute;
  width: 6px;
  height: 6px;
  background: #ff3b3b;
  border: 1px solid #fff;
  border-radius: 50%;
  box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.25);
  transform: translate(-50%, -50%);
  pointer-events: auto;
`;

export const KeypointsLabel = styled.div`
  position: absolute;
  bottom: 10px;
  left: 10px;
  background: rgba(0, 0, 0, 0.7);
  color: var(--ink);
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  z-index: 2;
  display: flex;
  align-items: center;
`;

export const FrameControlsBar = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  background: var(--surface);
  border-top: 1px solid var(--line);
  flex-wrap: wrap;
`;

export const FrameControlButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  background: var(--surface-2);
  border: 1px solid var(--line);
  color: var(--ink-2);
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;

  &:hover:not(:disabled) {
    border-color: var(--accent);
    color: var(--ink);
  }
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const FrameCounter = styled.span`
  color: var(--ink-2);
  font-family: var(--f-mono);
  font-size: 12px;
  min-width: 72px;
  text-align: right;
`;

export const ScrubBarTrack = styled.input.attrs({ type: 'range' })`
  flex: 1;
  min-width: 80px;
  height: 8px;
  -webkit-appearance: none;
  appearance: none;
  background: var(--line-2);
  border-radius: 4px;
  outline: none;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: var(--accent);
    cursor: pointer;
    border: 0;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.4);
  }
  &::-moz-range-thumb {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: var(--accent);
    cursor: pointer;
    border: 0;
  }
`;

export const PredictedViewBadge = styled.div`
  position: absolute;
  top: 8px;
  right: 12px;
  z-index: 10;
  background: color-mix(in srgb, var(--accent) 90%, transparent);
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  max-width: 260px;
  white-space: normal;
  word-break: break-word;
  line-height: 1.3;
`;
